import { Dispatch } from 'redux'
import { ActionType, PurchasesAction } from './actionTypes'
import { PurchaseOrder, Supplier } from './types'

export const updatePurchases = (purchases: PurchaseOrder[]) => {
    return (dispatch: Dispatch<PurchasesAction>) => {
        dispatch({
            type: ActionType.UPDATE_PURCHASES,
            payload: purchases
        })
    }
}

export const removePurchases = (ids: string[]) => {
    return (dispatch: Dispatch<PurchasesAction>) => {
        dispatch({
            type: ActionType.REMOVE_PURCHASES,
            payload: ids
        })
    }
}

export const updateSuppliers = (suppliers: Supplier[]) => {
    return (dispatch: Dispatch<PurchasesAction>) => {
        dispatch({
            type: ActionType.UPDATE_SUPPLIERS,
            payload: suppliers
        })
    }
}

export const removeSuppliers = (ids: string[]) => {
    return (dispatch: Dispatch<PurchasesAction>) => {
        dispatch({
            type: ActionType.REMOVE_SUPPLIERS,
            payload: ids
        })
    }
}

export const setCurrentPurchase = (purchase: PurchaseOrder) => {
    return (dispatch: Dispatch<PurchasesAction>) => {
        dispatch({
            type: ActionType.SET_CURRENT_PURCHASE,
            payload: purchase
        })
    }
}
